export function SET_TOKEN(state, token) {
  state.token = token;
}

export function SET_USER_DATA(state, data) {
  state.authenticatedUser = data;
}

export function SET_LOG_OUT(state) {
  state.authenticatedUser = null;
  state.token = null;
  localStorage.removeItem("token");
  localStorage.removeItem("organizationId");
  localStorage.removeItem("user");
  sessionStorage.clear();
}

export function SET_ERROR(state, error) {
  state.error = error;
}

export function SET_DATA_PROFILE(state, data) {
  let user = {
    userId: data.user._id,
    name: data.user.name,
    lastName: data.user.lastName,
    email: data.user.email,
    role: data.user.role,
    phone: data.user.phone,
    address: {
      street: data.user.address.street,
      interiorNumber: data.user.address.interiorNumber,
      exteriorNumber: data.user.address.exteriorNumber,
      suburb: data.user.address.suburb,
      zipCode: data.user.address.zipCode,
      city: data.user.address.city,
      state: data.user.address.state,
    },
  };

  localStorage.setItem("user", JSON.stringify(user));
}

export function SET_LOGIN_DATA_PROFILE(state, data) {
  let user = {
    userId: data.user._id,
    name: data.user.name,
    lastName: data.user.lastName,
    email: data.user.email,
    role: data.user.role,
    phone: data.user.phone,
    address: {
      street: data.user.address.street,
      interiorNumber: data.user.address.interiorNumber,
      exteriorNumber: data.user.address.exteriorNumber,
      suburb: data.user.address.suburb,
      zipCode: data.user.address.zipCode,
      city: data.user.address.city,
      state: data.user.address.state,
    },
  };
  SET_PERMISSIONS(state, data.user.roles);
  localStorage.setItem("token", data.user.token);
  localStorage.setItem(
    "organizationId",
    data.user.commercialOrganizationId ? data.user.commercialOrganizationId : ""
  );
  localStorage.setItem(
    "distributionOrganizationId",
    data.user.distributionOrganizationId
      ? data.user.distributionOrganizationId
      : ""
  );
  localStorage.setItem("user", JSON.stringify(user));
  sessionStorage.setItem("authenticated", true);

  state.token = data.user.token;
  state.authenticatedUser = user;
}

export function UPDATE_USER_INFO(state, data) {
  let user = {
    userId: data.user._id,
    name: data.user.name,
    lastName: data.user.lastName,
    email: data.user.email,
    role: data.user.role,
    phone: data.user.phone,
    address: {
      street: data.user.address.street,
      interiorNumber: data.user.address.interiorNumber,
      exteriorNumber: data.user.address.exteriorNumber,
      suburb: data.user.address.suburb,
      zipCode: data.user.address.zipCode,
      city: data.user.address.city,
      state: data.user.address.state,
    },
  };
  SET_PERMISSIONS(state, data.user.roles);
  localStorage.setItem(
    "organizationId",
    data.user.commercialOrganizationId ? data.user.commercialOrganizationId : ""
  );
  localStorage.setItem(
    "distributionOrganizationId",
    data.user.distributionOrganizationId
      ? data.user.distributionOrganizationId
      : ""
  );
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("companyDistributorName", data.distributorName);
  state.authenticatedUser = user;
}

export function SET_PERMISSIONS(state, userRoles) {
  let allPermissions = userRoles.map((role) => role.permissions);
  let permissionsFiltered = [...new Set(allPermissions.flat())];
  state.permissions = permissionsFiltered;
}

export function SET_LANGUAGE(state, language) {
  localStorage.setItem("language", language);
  state.language = language;
}
